import styles from './Header.module.css';
export default function Header() {
  return (<header className={styles.h}>
    <div className={styles.l}><span>🌙</span><div>
      <h1 className={styles.t}>رمضان في مصر — Egyptian Ramadan Time Machine</h1>
      <p className={styles.s}>Relive every Ramadan since the 90s</p>
    </div></div>
  </header>);
}